import { FETCH_ALL, POST, UPDATE, DELETE, SORT } from "./../constants/action_types";

const post_handler = (posts = [], action) =>
{
  switch (action.type)
  {
    case FETCH_ALL:
      /**
       * Return and store new array with all posts fetched from api
       */
      return action.payload;
    case POST:
      /**
       * Return and store new array with all posts and the new post
       */
      return [...posts, action.payload];
    case UPDATE:
      /**
       * To explain what the fuck is going on here
       * This checks every post and checks if it was the one that was updated
       * If it was updated it will return the payload, the return data from the api
       * If it wasn't updated it will simply return the post as it was
       */
      return posts.map((post) => post._id === action.payload._id ? action.payload : post);
    case DELETE:
      /**
       * Return and store new array with all posts that don't match the deleted post
       */
      return posts.filter((post) => post._id !== action.payload);
    case SORT:
      /**
       * Return and store new array with all posts sorted by rating
       * Sorted in descending or ascending order based on order type of action
       */

      const hold = [...action.payload.data];
      let sorted_posts;

      switch (action.payload.descending)
      {
        case true:
          sorted_posts = hold.sort((a, b) => b.rating - a.rating);
          break;
        case false:
          sorted_posts = hold.sort((a, b) => a.rating - b.rating);
          break;
        default:
          console.log("How there would be a third option idk but the compiler keeps yelling at me");
      }
      return sorted_posts;
    default:
      return posts;
  }
}

export default post_handler;
